import { useStore, useStoreMap, useGate } from 'effector-react'
import { Form } from '~/entities/africa/Organizations/CarRental'
import { carRentalModel } from '~/entities/common/Organizations/CarRental'
import { usePermissions } from '~/entities/common/viewer'
import { formSubmitted, Gate, $carRental, carRentalUpdateFx } from './model'

type EditCarRentalProps = {
  carRentalId: string
}

export function EditCarRental({ carRentalId }: EditCarRentalProps) {
  useGate(Gate, { carRentalId })
  const { canUpdateCarRentals } = usePermissions()

  const isLoading = useStore(carRentalModel.requestFx.pending)
  const isSaving = useStore(carRentalUpdateFx.pending)

  const defaultValues = useStoreMap($carRental, (carRental) => ({
    ...carRental?.getAttributes(),
  }))

  return (
    <Form
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canUpdateCarRentals}
    />
  )
}
